import { api,getPostBlob,getBlob } from "../../services/NetworkBase";
// import { api ,getBlob} from "../../services/NetworkBase";
import { saveAs } from "file-saver";

export async function GetLabOrders(startDate, endDate, orderStatus, accountNumbers, searchText, page, pageSize) {   
    try {		
        let response = await api
            .get(`vlp/lab-orders?startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&page=${page}&orderStatus=${orderStatus}&accountNumbers=${accountNumbers}&pageSize=${pageSize}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}

export async function GetShippedOrders(startDate,endDate,searchText, page,pageSize) {	
	try {
		let response = await api
		.get(`vlp/lab-orders/shipped?startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&page=${page}&pageSize=${pageSize}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function GetEtkOrders(startDate, endDate, page, pageSize, searchText = "") {
  try {
    let response = await api
      .get(`vlp/lab-orders/etk-orders?startDate=${startDate}&endDate=${endDate}&page=${page}&pageSize=${pageSize}&searchText=${encodeURIComponent(searchText ?? "")}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetLabOrder(orderNumber) {	
	try {
		let response = await api
		.get(`vlp/lab-orders/${orderNumber}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}


export async function GetOrderResultById(orderNumber, recordId) {	
	try {
		let response = await api
		.get(`vlp/lab-orders/${orderNumber}/results/${recordId}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function GetOrderResultsByOrderNumber(orderNumber) {	
	try {
		let response = await api
		.get(`vlp/lab-orders/results/${orderNumber}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function GenerateAiSummary(orderNumber) {
	try {
		let response = await api
		.post(`vlp/lab-orders/${orderNumber}/generate-ai-summary`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function UpdateAiSummary(orderNumber, aiSummary) {
	try {
		let response = await api
		.put(`vlp/lab-orders/${orderNumber}/ai-summary`, { json: { aiSummary } })
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function MarkAiSummaryReviewed(orderNumber) {
	try {
		let response = await api
		.post(`vlp/lab-orders/${orderNumber}/ai-summary/review`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

// Opens the order's lab report PDF in a new tab
export async function GenerateLabReport(orderNumber) {
	let blob = await getBlob(`vlp/lab-orders/${orderNumber}/lab-report`);
	const url = window.URL.createObjectURL(blob);
	window.open(url, "_blank");
}

export async function EmailLabReport(orderNumber) {
	try {
		let response = await api
		.post(`vlp/lab-orders/${orderNumber}/email-lab-report`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function UploadToCMDP(orderNumber) {
	try {
		let response = await api
		.get(`vlp/lab-orders/upload-cmdp/${orderNumber}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

//UpdateLabOrder
export async function UpdateLabOrder(ordersReportDto) {
	try {
	  let response = await api.put(
		"vlp/lab-orders",
		{ json: ordersReportDto }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

export async function UpdateOrdersReportInfo(ordersReportDto) {
	try {
	  let response = await api.put(
		"vlp/lab-orders/report-info",
		{ json: ordersReportDto }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

export async function GetOrderAttachments(orderNumber) {	
	try {
		let response = await api
		.get(`vlp/lab-orders/attachments/${orderNumber}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}


export async function UploadOrderAttachment(formData) {
  try {
    let response = await api
      .post('vlp/lab-orders/attachments/upload', {
        body: formData,
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}


export async function GetOrdersByAccountNumber(refreshCount,  accountNumber) {	
	try {
		let response = await api
		.get(`vlp/lab-orders/refresh-count/${refreshCount}/account-number/${accountNumber}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function DeleteOrderAttachment(orderNumber,id) {   
    try {        
        let response = await api
        .delete(`vlp/lab-orders/${orderNumber}/attachments/${id}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}

//SaveOrderResult
export async function SaveOrderResult(result) {
	try {
	  let response = await api.post(
		"vlp/lab-orders/results",
		{ json: result }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

  export async function UpdateOrderResult(result) {
	try {
	  let response = await api.put(
		"vlp/lab-orders/results",
		{ json: result }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

    export async function BulkUpdateOrderResult(result) {
	try {
	  let response = await api.put(
		"vlp/lab-orders/results/bulk",
		{ json: result }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

  export async function ReserveLabOrders(dto) {
	try {
	  let response = await api.post(
		"vlp/lab-orders/reserve-order",
		{ json: dto }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

  export async function CreateETKBulkOrders(orders) {
  try {
	const count = orders.kitCount;
    const accountNumber = orders.accountNumber ?? "NA";
    const user = orders.user.trim() ?? "Unknown";

    // Month names
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    // Time parts
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // convert to 12-hour format
    const hourStr = String(hours).padStart(2, "0");

    const timeString = `${hourStr}_${minutes}_${seconds}_${ampm}`;

    const fileName = `BulkETKOrders_Total_${count}_Acc_${accountNumber}_User_${user}_${day}_${month}_${year}_${timeString}.xlsx`;

    const blob = await getPostBlob(
      "vlp/lab-orders/bulk-orders",
      orders
    );

    
    saveAs(blob, fileName);
    return true;
  } catch (error) {
    console.error("Error creating bulk ETK orders:", error);
    throw error;
  }
}




    export async function UpdateOrderResultAnalyticValues(result) {
	try {
	  let response = await api.put(
		"vlp/lab-orders/results/analytic-values",
		{ json: result }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

export async function CalculateOrderResult(recordIds) {
  try {
    let response = await api.put(
      "vlp/lab-orders/results/calculate",
      { json: recordIds }  
    );
    return response;
  } catch (error) {
    console.error("CalculateOrderResult service error:", error);
    throw error;
  }
}



  export async function GenerateOrderResultsReport(orderNumbers) {
  try {
	const count = orderNumbers?.length ?? 0;

    // Month names
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    // Time parts
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const hourStr = String(hours).padStart(2, "0");

    const timeString = `${hourStr}_${minutes}_${seconds}_${ampm}`;

    const fileName = `OrderResultsReport_Total_${count}_${day}_${month}_${year}_${timeString}.pdf`;

    const blob = await getPostBlob(
      "vlp/lab-orders/results/report",
      orderNumbers
    );

    
    saveAs(blob, fileName);
    return true;
  } catch (error) {
    console.error("Error creating results report:", error);
    throw error;
  }
}



export async function GetOrderDocument(title, description) {
  // getBlob already returns a blob directly, not a Response object
  const blob = await getBlob(
    `vlp/lab-orders/order/document?title=${encodeURIComponent(
      title
    )}&description=${encodeURIComponent(description)}`
  );

  return blob; // return the blob directly
}

export async function SaveOrderSample(sample) {
	try {
	  let response = await api.post(
		"vlp/lab-orders/samples",
		{ json: sample }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }


  export async function UpdateOrderSample(sample) {
	try {
	  let response = await api.put(
		"vlp/lab-orders/samples",
		{ json: sample }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

export async function DeleteOrderResult(orderNumber,id) {   
    try {        
        let response = await api
        .delete(`vlp/lab-orders/${orderNumber}/results/${id}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}

export async function GetOrderSample(orderNumber,id) {   
    try {        
        let response = await api
        .get(`vlp/lab-orders/${orderNumber}/samples/${id}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}


export async function GetOrderSampleResult(orderNumber,id,methodCode) {   
    try {        
        let response = await api
        .get(`vlp/lab-orders/${orderNumber}/samples/${id}/method-code/${methodCode}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}


  export async function DeleteOrderSample(orderNumber,id) {   
    try {        
        let response = await api
        .delete(`vlp/lab-orders/${orderNumber}/samples/${id}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}


export async function DeleteLabOrder(orderNumber) {   
    try {        
        let response = await api
        .delete(`vlp/lab-orders/${orderNumber}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}


export async function DuplicateOrderSample(orderNumber, sampleId, options) {
    try {
        let response = await api
            .post(`vlp/lab-orders/${orderNumber}/samples/${sampleId}/duplicate`, {
                json: options,
            })
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}

// ENB-583: add tests (or a slate's tests) to a sample on the order.
// body: { testCodes: string[], jobId?: string, assignToAllSamples: boolean }
export async function AddTestsToSample(orderNumber, sampleId, body) {
    try {
        let response = await api
            .post(`vlp/lab-orders/${orderNumber}/samples/${sampleId}/tests`, {
                json: body,
            })
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}
